module.exports = __webpack_public_path__ + "e34379dbf1cd4b590d131b86f6d3233e.png";